import React, { Fragment } from "react";
import { Col, Row } from "antd";
import DiscussionTeam from "./DiscussionTeam";
import ScrollToTop from "../../../../common/cards/ScrollToTop";
import { PROFILE } from "../../../../Store/Features/ProfileSlice";
import { useSelector } from "react-redux";
import { ROLES } from "../../../../Config/helpers/constants";
import { SideBar } from "../../../../common/leftsidebar";
const TimeLine = () => {
  const userDetails = useSelector(PROFILE);
  return (
    <Fragment>
      <ScrollToTop />
      <Row justify="center" gutter={[20, 0]} className="rowPadding">
        <SideBar
          current={ROLES.team}
          noExploreEvents
          eventHistoryLInk={`/view/team/${userDetails?._id}/eventhistory`}
        />
        <Col
          xs={{ span: 24, order: 3 }}
          sm={{ span: 24, order: 3 }}
          md={{ span: 24, order: 3 }}
          lg={{ span: 14, order: 2 }}>
          {userDetails?._id ? <DiscussionTeam /> : null}
        </Col>
      </Row>
    </Fragment>
  );
};

export default TimeLine;
